module.exports = __webpack_public_path__ + "media/images/gallery/pn_l-26b924b57c4138d2bdefa49ffa754c69.gif";